
export class GetJobsByIdApiDto {
    /**
     *
     */
    constructor(
        public jobIds: number[]
    ) { }
}